<template>
	<div class="about1">
		<div class="about1-c new-about1-c">
			<div class="about1-info">
				<div class="about1-info-h">浙江中概电力科技有限公司</div>
				
				<p class="about1-info-f1">
				    <img src="../../assets/newimg/202.jpg" align="left" width="58%" hspace="10" vspace="10">
				
					<p class="about1-info-f1-p about1-info-f1-p-zh">
						<p>
							<span style="text-indent:28px;">
							 中概电力创建于2015年，坐落于杭州市，系为深耕风力与光伏发电、储能等新能源领域的高新技术企业。公司集技术研发、项目开发与投资、系统设计与集成、建设与运维等业务于一体，专注于光伏、储能、分散式风电、电力及运维五大核心板块的投资与建设。公司具有电力工程总承包二级、承装承修承试四级等专业资质，聚集了一大批具有丰富经验、技术精湛的风电、光伏和电力行业人才，系国内最早从事光伏发电和储能业务的新能源开发与建设企业之一。
						    </span>
							<span style="text-indent:28px;">
							 公司现有110余名各类专业组成的团队，其中具有中高级职称专业技术20余人、 国家注册建造师执业资格的工程管理人员10余名，60多名的技工团队，管理团队具有良好的电力和新能源职业背景，拥有丰富的管理经验与专业能力; 拥有各项专利12项，其中发明专利1个项，软著2项；荣获了浙江省“国家科技型中小企业”、杭州拱墅区“经济贡献优秀奖”、“AAA级信用企业”等荣誉；通过了
							ISO9001质量管理体系、 ISO14000环境管理体系、ISO45001职业健康安全管理体系和SA8000企业社会责任管理体系等认证。
							</span>
							<span style="text-indent:28px;">
							 公司秉承“客赢共兴、协作担当、创新拼搏、追求卓越”价值观，鼓励创新、精工务实，同时本着“客户至上”理念，为客户提供专业、高质量的智慧能源解决方案；以“科技赋能，点亮绿色未来”为企业使命，专注于智慧能源技术的研发与创新，致力推动中国绿色经济的发展。
							</span>
						</p>
					</p>
				</p>
				
				<!-- <div class="about1-info-f"  style="background-color: white; padding: 30px;">
					<img src="../../assets/newimg/202.jpg" alt />
					<div class="about1-info-f-r">
						<div class="t">
							中概电力创建于2015年，坐落于杭州市，系为深耕风力与光伏发电、储能等新能源领域的高新技术企业。公司集技术研发、项目开发与投资、系统设计与集成、建设与运维等业务于一体，专注于光伏、储能、分散式风电、电力及运维五大核心板块的投资与建设。公司具有电力工程总承包二级、承装承修承试四级等专业资质，聚集了一大批具有丰富经验、技术精湛的风电、光伏和电力行业人才，系国内最早从事光伏发电和储能业务的新能源开发与建设企业之一。
						</div>
						<div class="t">
							公司现有110余名各类专业组成的团队，其中具有中高级职称专业技术20余人、国家注册建造师执业资格的工程管理人员10余名，60多名的技工团队，管理团队具有良好的电力和新能源职业背景，拥有丰富的管理经验与专业能力；拥有各项专利12项，其中发明专利1个项，软著2项；荣获了浙江省“国家科技型中小企业”、杭州拱墅区“经济贡献优秀奖”、“AAA级信用企业”等荣誉；通过了
							ISO9001质量管理体系、 ISO14000环境管理体系、 ISO45001职业健康安全管理体系和SA8000企业社会责任管理体系等认证。
						</div>
						<div class="t">
							公司秉承“客赢共兴、协作担当、创新拼搏、追求卓越”价值观，鼓励创新、精工务实，同时本着“客户至上”理念，为客户提供专业、高质量的智慧能源解决方案；以“科技赋能，点亮绿色未来”为企业使命，专注于智慧能源技术的研发与创新，致力推动中国绿色经济的发展。
						</div>
					</div>
				</div> -->
			</div>
		</div>
		<div class="about1-c1">
			<img class="about-bgimg" src="../../../public/about/about-2.png" alt />
			<div class="about1-c1-c">
				<div class="about1-c1-header">
					<div class="h">
						<div>团队组成</div>
					</div>
					<div class="f"></div>
				</div>
				<div class="about1-c1-c1">{{num3}}<p>+ 名</p></div>
				<div class="about1-c1-c2">110余名各类专业组成的团队</div>
				<div class="about1-c1-c3">
					<span>公司下辖"市场开发、技术质量、工程管理、财务、综合"五大中心和"电力和运维"两个事业部。</span>
					
					管理团队具有良好的电力和新能源职业背景，拥有丰富的管理经验与专业能力；<br>
					公司具备健全的组织架构、优秀的管理和各类专业团队、丰富的技术沉淀、良好质量保证体系和完善的管理，为公司<br>持续健康发展奠定了坚实的基础和保障。
				</div>

				<div class="about1-c1-c4">
					<div class="item">
						<div class="item-t">
							<div class="t">
								{{num4}}
								<span>大中心</span>
							</div>
							<div class="s">
								市场开发、技术质量、<br>
								工程管理、财务、综合管理
							</div>
						</div>
						<img src="../../../public/about/about-3.png" alt />
					</div>
					<div class="item">
						<div class="item-t">
							<div class="t">
								{{num5}}
								<span>个事业部</span>
							</div>
							<div class="s">"电力和运维"<br>两个事业部</div>
						</div>
						<img src="../../../public/about/about-4.png" alt />
					</div>
					<div class="item">
						<div class="item-t">
							<div class="t">
								{{num8}}
								<span>+名</span>
							</div>
							<div class="s">国家注册建造师执业资格的<br>
								工程管理人员</div>
						</div>
						<img src="../../../public/about/about-7.png" alt />
					</div>
					<div class="item">
						<div class="item-t">
							<div class="t">
								{{num6}}
								<span>+名</span>
								<!-- <span class="jia">+</span>
								<span>名</span> -->
							</div>
							<div class="s">
								具有中高级职称<br>
								专业技术人才
							</div>
						</div>
						<img src="../../../public/about/about-5.png" alt />
					</div>
					<div class="item">
						<div class="item-t">
							<div class="t">
								{{num7}}
								<span>+名</span>
								<!-- <span class="jia">+</span>
								<span>名</span> -->
							</div>
							<div class="s">
								技工团队
							</div>
						</div>
						<img src="../../../public/about/about-6.png" alt />
					</div>
				</div>
			</div>
		</div>
		
		<div class="mobile-about1-c2">
			<div class="mobile-abount1c2-title">发展历程</div>
			<swiper v-if="timelineData.length > 0" class="swiper-container"
				:style="{height:'auto',width:'100%;'}" @swiper="onSwiper" @slideChange="onSlideChange"
				:modules="modules" :pagination="{ clickable: true }"  :direction='horizontal' :navigation="false" :loop="true">
				<swiper-slide class="banner" style="width: 100%; height: 100%;" v-for="(item, index) in timelineData" :key="index">
					<div class="about1-info-box-s-h">{{timelineData[index].year}}年</div>
					<div class="about1-info-box-s-s" v-for="(itemx, indexx) in timelineData[index].events"
						:key="indexx">
						<div class="about1-info-box-s-s-yuan"></div>
						<div class="about1-info-box-s-s-sec">{{itemx}}</div>
					</div>
				</swiper-slide>
				<div class="pagination new-pagination">
					<div v-for="(item, index) in timelineData.length" :key="index" :class="cIndex == index?'sdiv':''"></div>
				</div>
			</swiper>
		</div>
		
		<div class="about1-c2">
			
			<img class="about1-info-bg" src="../../assets/about/about-11.png" alt="" />
			
			<div class="about1-info">
				<!-- <div class="about1-info-h">发展历程</div> -->

				
				<div class="about1-info-box">
					<div class="about1-info-box-h">发展历程</div>
					<div class="about1-info-box-s">
						<div class="about1-info-box-s-h">{{timelineData[selectIndex].year}}年</div>
						<div class="about1-info-box-s-s" v-for="(item, index) in timelineData[selectIndex].events"
							:key="index">
							<div class="about1-info-box-s-s-yuan"></div>
							<div class="about1-info-box-s-s-sec">{{item}}</div>
						</div>

					</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b1" @click="tapIndex(0)">
					<div class="blinking-circle" :class="selectIndex==0?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t">{{timelineData[0].year}}</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b2" @click="tapIndex(1)">
					<div class="blinking-circle" :class="selectIndex==1?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t">{{timelineData[1].year}}</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b3" @click="tapIndex(2)">
					<div class="blinking-circle" :class="selectIndex==2?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t">{{timelineData[2].year}}</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b5" @click="tapIndex(3)">
					<div class="blinking-circle" :class="selectIndex==3?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t">{{timelineData[3].year}}</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b6" @click="tapIndex(4)">
					<div class="blinking-circle" :class="selectIndex==4?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t">{{timelineData[4].year}}</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b7" @click="tapIndex(5)">
					<div class="blinking-circle" :class="selectIndex==5?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t" style="">{{timelineData[5].year}}</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b8" @click="tapIndex(6)">
					<div class="blinking-circle" :class="selectIndex==6?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t" style="">{{timelineData[6].year}}</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b9" @click="tapIndex(7)">
					<div class="blinking-circle" :class="selectIndex==7?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t" style="">{{timelineData[7].year}}</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b10" @click="tapIndex(8)">
					<div class="blinking-circle" :class="selectIndex==8?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t" style="">{{timelineData[8].year}}</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b11" @click="tapIndex(9)">
					<div class="blinking-circle" :class="selectIndex==9?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t" style="">{{timelineData[9].year}}</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b12" @click="tapIndex(10)">
					<div class="blinking-circle" :class="selectIndex==10?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t" style="">{{timelineData[10].year}}</div>
				</div>
				<!-- <div class="blinking-circle-b blinking-circle-b13" @click="tapIndex(11)">
					<div class="blinking-circle" :class="selectIndex==11?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t" style="">{{timelineData[11].year}}</div>
				</div> -->

			</div>
		</div>
	</div>
</template>

<script>
	import {
		Swiper,
		SwiperSlide
	} from 'swiper/vue';
	import {
		Navigation,
		Pagination,
		A11y,
		Autoplay
	} from 'swiper/modules';
	import 'swiper/css';
	import 'swiper/css/navigation';
	import 'swiper/css/pagination';
	import 'swiper/css/autoplay';
	
	export default {
		components: {
			Swiper,
			SwiperSlide,
		},
		props: {
			list: {
				type: Array,
				default: []
			},
			list1: {
				type: Array,
				default: []
			},

		},
		data() {
			return {
				num1: 0,
				num2: 0,
				num3: 0,

				num4: 0,
				num5: 0,
				num6: 0,
				num7: 0,
				num8: 0,

				increment: 1, // 每次增加的数值
				numto1: 110,
				intervalId1: null,
				
				modules: [A11y, Autoplay],
				cIndex: 0,
				
				selectIndex: 10,
				timelineData: [{
						year: "2015",
						events: ["杭州中概装饰工程有限公司成立。"]
					},
					{
						year: "2016",
						events: [
							"更名为杭州中概电力工程有限公司；",
							'正式进入分布式光伏行业，首次承接杭州帷盛科技1MW分布式光伏业务。'
						]
					},
					{
						year: "2017",
						events: [
							"攻克行业内多项技术难题，为世界五百强中大元通物流园完成首个6MW BIPV分布式光伏项目建设，该项目被列入杭州市创新案列，被市光伏协会、国家能源等专家列为示范项目，多次迎接各类专家参观学习；",
							'实现分布式光伏项目装机容量累计达100MW，分别建设了嘉士工业园4.5MW、台州华迪5.5MW、奥利达电梯4.7MW等大型分布式光伏项目。'
						]
					},
					{
						year: "2018",
						events: [
							"杭州中概电力工程有限公司更名为浙江中概电力工程有限公司；",
							'进入大有电力系统白名单，承接镇中变110变电站业务；',
							'建成并自持各类光伏电站累计超200MW， 同时进入EPC领域。'
						]
					},
					{
						year: "2019",
						events: [
							"顺利通过ISO9000、ISO14000体系认证，内部管理逐步提升；",
							'与富春江集团签订战略合作协议，承接永特信息、永特电缆5.3872MW光伏项目。'
						]
					},
					{
						year: "2020",
						events: [
							"与凯达、远景建立战略合作关系；",
							'承接甬台温高速公路复线温州瑞安至苍南（浙闽界）段公路变配电安装工程。',
						]
					},
					
					{
						year: "2021",
						events: [
							"与江苏天电、正泰集团建立战略合作关系；",
							'承接承德县“十三五”第二批村级光伏扶贫电站项目。'
						]
					},
					
					{
						year: "2022",
						events: [
							"荣获国家科技型中小企业称号；",
							'信息化平台建设包括：工程宝、供应链、金蝶系统上线；',
							'承接杭汽轮12MW屋顶分布式光伏发电项目；',
							'承接广东双林生物有限公司10kV配电项目。'
						]
					},
					
					{
						year: "2023",
						events: [
							"通过SA8000社会责任体系认证；",
							'荣获拱墅区经济贡献优秀奖；',
							'与杭泰、华电浙江公司建立战略合作关系；',
							'订单业务实现跨越式突破，EPC业务年装机容量超百兆瓦；',
							'首次承接百米高楼光伏项目及首次创新应用钙钛矿组件（余杭区政府1.2MW光伏电站）；',
							'首次在隧道创新应用柔性组件光伏项目（运溪隧道236.25kWp光伏项目）。'
						]
					},					
					{
						year: "2024",
						events: [
							"“定战略，调机构、夯基础、谋发展”战略调整年，确立三大业务、五大板块战略，成立电力事业部与运维事业部；",
							"与江苏悦达、中车、广东建工、东方雨虹建立战略合作关系；",
							"承接上海松江高铁站配电项目、台州国家博览中心6MW光伏项目；",
							"承接汾口宋京油茶40WM农光互补项目EPC工程。"
						]
					},
					{
						year: "2025",
						events: [
							"浙江中概电力工程有限公司更名为浙江中概电力科技有限公司"
						]
					},


				],

			};
		},
		created() {
			var that = this
			this.intervalId1 = setInterval(function() {

				if (that.num1 < 9) {
					that.num1++;
				}
				if (that.num2 < 20) {
					that.num2++;
				}

				if (that.num4 < 5) {
					that.num4++;
				}
				if (that.num5 < 2) {
					that.num5++;
				}
				if (that.num6 < 20) {
					that.num6++;
				}
				if (that.num7 < 60) {
					that.num7++;
				}
				if (that.num8 < 10) {
					that.num8++;
				}

				if (that.num3 < 110) {
					that.num3++;
				} else {
					clearInterval(that.intervalId1); // 达到目标值后清除定时器
				}
			}, 80);

		},
		mounted() {


		},
		beforeDestroy() {
			clearInterval(this.intervalId1); // 清除定时器，避免内存泄漏

		},
		methods: {

			tapIndex(index) {
				this.selectIndex = index
			},
			
			onSwiper(e) {
			
			},
			onSlideChange(e) {
			
				this.cIndex = e.realIndex
				console.log('Active index:', this.cIndex);
			},
			
		}
	};
</script>

<style lang="scss">
	div {
		box-sizing: border-box;
	}
	
	.mobile-about1-c2{
		display: none;
	}

	.about1 {
		width: 100%;

		.about1-c {
			background-color: white;
			justify-content: center;
			
			background: url('../../assets/about/about-bg.png') no-repeat 100% 100%;
			background-size: cover;
			.about1-info {

				// background-image: url(../../assets/about/about-11.png);
				// background-size: 100%;
				// background-repeat: no-repeat;
				.about1-info-h {
					color: #332c2b;
				}

				.about1-info-f {
					flex-direction: row;
					justify-content: space-between;
					align-items: center;

					.about1-info-f-r {
						.t {
							font-family: AlibabaPuHuiTi-Regular;
							font-weight: 400;
							color: #332c2b;
							letter-spacing: 0;
							// display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 15;
							text-indent: 4ch;
						}

						.s {
							justify-content: space-between;
							align-items: center;

							.s-l {
								color: #22A3D3;
							}

							.s-r {
								color: #332c2b;
							}
						}
					}
				}
			}
		}

		.about1-c1 {
			justify-content: center;
			position: relative;

			.about-bgimg {
				position: absolute;
				z-index: 1;
			}

			.about1-c1-c {
				position: relative;
				z-index: 3;

				.about1-c1-header {
					.h {
						div {
							color: white;
						}
					}
				}

				.about1-c1-c1 {
					color: #fff;
					font-size:64px;
					padding-top:30px;
					p{
						display: inline-block;
						top:0;
						vertical-align: top;
						padding-left:10px;
						position:relative;
						font-size:16px;
					}
				}

				.about1-c1-c2 {
					color: #fff;
				}

				.about1-c1-c3 {
					color: #ffffff;
					line-height:30px;
					span{
						display:block;
						margin-bottom:10px;
					}
				}

				.about1-c1-c4 {
					display: flex;
					justify-content: space-between;

					.item {
						display: flex;
						flex-direction: column;
						justify-content: space-between;

						.t {
							color: #fff;
							span{
								display: inline-block;
								vertical-align: super;
								font-size:16px;
							}
						}

						.s {
							color: #ffffff;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 4;
							/* 限制为3行 */
							overflow: hidden;
						}
					}
				}
			}
		}

		.about1-c2 {
			width: 100%;
			display: flex;
			background-color: #22A3D3;
			position: relative;
			.about1-info {
				width: 100%;
			}

			.about1-info-bg {
				width: 100%;
				height: auto;
				min-width:100%;
			}

			.about1-info-box {
				position: absolute;
				top: 0;


				.about1-info-box-h {
					text-align: center;
					font-family: AlibabaPuHuiTi-Medium;
					font-weight: 500;
					color: #332C2B;
				}

				.about1-info-box-s {
					text-align: left;

					.about1-info-box-s-h {
						font-family: BebasNeue-Regular;
						font-weight: 400;
						color: #22A3D3;
					}

					.about1-info-box-s-s {
						font-family: BebasNeue-Regular;
						color: #333333;

						display: flex;
						justify-content: flex-start;
						align-items: center;

						.about1-info-box-s-s-yuan {

							background-color: #22A3D3;
						}
					}

				}
			}

			.blinking-circle-b {
				position: absolute;

				justify-content: center;
				align-items: center;
				flex-direction: column;
				color: white;
				font-family: AlibabaPuHuiTi-Medium;
				font-weight: 500;

			}

			.blinking-circle {

				background-image: radial-gradient(circle, #B3B3B3 60%, transparent 60%);
				border-radius: 50%;
				border: 2px solid transparent;
				animation: combinedEffect 1.5s infinite;

				@keyframes combinedEffect {

					0%,
					100% {
						box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
						border-color: transparent;
					}

					50% {
						box-shadow: 0 0 0 10px rgba(0, 141, 142, 0);
						border-color: rgba(255, 255, 255, 0.7);
					}
				}
			}





			.blinking-circle-s {
				background-image: radial-gradient(circle, #22A3D3 60%, transparent 60%);
				border-radius: 50%;
				border: 2px solid transparent;
				animation: combinedEffect 1.5s infinite;

				@keyframes combinedEffect {

					0%,
					100% {
						box-shadow: 0 0 0 0 rgba(0, 141, 142, 0.7);
						border-color: transparent;
					}

					50% {
						box-shadow: 0 0 0 10px rgba(0, 141, 142, 0);
						border-color: rgba(255, 255, 255, 0.7);
					}
				}
			}



		}
	}



	@media screen and (min-width: 1200px) {
		.about1 {
			width: 100%;

			.about1-c {
				width: 100%;
				display: flex;
				padding: 120px 0 120px;

				.about1-info {
					width: 1200px;
					
					.about1-info-bg {
						width: 100%;
						height: auto;
					
					}

					.about1-info-h {
						font-size: 32px;
					}
					
					.about1-info-f1 {
						font-size: 17px;
						img{
							display: inline-block;
							margin-right:0 ;
							margin-left:0 ;
							height:545px;
						}
						p.about1-info-f1-p{
							width:42%;
							padding-top:0;
							margin-top:0;
							display:inline-block;
							p{
								font-size:14px;
								padding-left:50px;
								padding-top:0;
								margin-top:5px;
								line-height:28px;
								span{
									display: block;
									margin-bottom:12px;
								}
							}
						}
					}

					.about1-info-f {
						width: 100%;
						margin-top: 55px;
						display: flex;

						img {
							width: 50%;
							// height: 495px;
						}

						.about1-info-f-r {
							margin-left: 30px;
							width: calc(50% - 30px);

							.t {
								font-size: 17px;
								color: #332c2b;
								line-height: 24px;
							}

							.s {
								margin-top: 13px;
								height: 106px;
								border-bottom: 1px solid #f1f1f1;
								display: flex;

								.s-l {
									font-size: 62px;
								}

								.s-r {
									font-size: 18px;
								}
							}
						}
					}
				}
			}

			.about1-c1 {
				width: 100%;
				display: flex;
				padding-top: 90px;

				.about-bgimg {
					width: 100%;
					height: 100%;
					top: 0;
					left: 0;
				}

				.about1-c1-c {
					width: 1200px;

					.about1-c1-header {
						width: 100%;

						.h {
							height: 100px;
							line-height: 100px;
							border-bottom: 1px solid #aaa;

							div {
								width: 180px;
								height: 100px;
								font-size: 32px;
								border-bottom: 2px solid white;
							}
						}
					}

					.about1-c1-c1 {
						color: #fff;
						font-size:64px;
						p{
							display: inline-block;
							top:0;
							vertical-align: top;
							padding-left:10px;
							position:relative;
							font-size:16px;
						}
					}

					.about1-c1-c2 {
						font-size: 18px;
					}

					.about1-c1-c3 {
						margin-top: 20px;
						font-size: 16px;
					}

					.about1-c1-c4 {
						margin-top: 60px;
						height: 304px;
						display: flex;
						
						.item {
							height: 100%;
							flex: 1;
							height: 304px;
							border-left: 1px solid #aaa;
							padding: 40px 35px;

							.t {
								font-size: 56px;
								height: 60px;
								
								span {
									font-size: 20px;
									display: inline-block;
									vertical-align: super;
									position:relative;
									top:-10px;
									font-size:16px;
							
								}

								.jia {
									font-size: 30px;
								}
							}


							.s {
								max-height: 120px;
								padding-top: 10px;
								// font-size: 16px;
								font-size:14px;
							}

							img {
								// margin-top: 49px;
								width: 48px;
								height: 48px;
							}


						}
					}
				}
			}

			.about1-c2 {


				.about1-info-box {
					left: calc(50% - 600px);
					width: 1200px;
					height: 100%;

					.about1-info-box-h {
						padding-top: 35px;
						font-size: 30px;
					}

					.about1-info-box-s {
						margin-top: 20px;

						.about1-info-box-s-h {
							font-size: 38px;
							margin-bottom: 16px;
						}

						.about1-info-box-s-s {
							// width: 50%;
							width:80%;
							font-size: 20px;
							line-height: 23px;
							margin-bottom: 16px;
							position:relative;
							.about1-info-box-s-s-yuan {
								width: 10px;
								height: 10px;
								border-radius: 5px;
								margin-right: 10px;
								display: inline-block;
								position:absolute;
								top:11px;
							}

							.about1-info-box-s-s-sec {
								padding-left:20px;
								line-height: 30px;
								width: calc(100% - 20px);
								display: inline-block;
							}
						}

					}
				}

				.blinking-circle-b {
					font-size: 18px;
					display: flex;

					.blinking-circle-b-t {
						margin-top: 5px;
						color: #22A3D3;
					}
				}

				.blinking-circle {
					width: 24px;
					height: 24px;
				}


				.blinking-circle-b1 {
					top: 87%;
					left: 20%;
				}

				.blinking-circle-b2 {
					top: 80%;
					left: 25%;
				}

				.blinking-circle-b3 {
					top: 73%;
					left: 34%;
				}

				.blinking-circle-b4 {
					top: 70%;
					left: 43%;
				}

				.blinking-circle-b5 {
					top: 70%;
					left: 43%;
				}

				.blinking-circle-b6 {
					top: 63%;
					left: 47%;
				}

				.blinking-circle-b7 {
					top: 57%;
					left: 53%;
				}

				.blinking-circle-b8 {
					top: 52%;
					left: 60%;
				}
				
				.blinking-circle-b9 {
					top: 47%;
					left: 65%;
				}
				.blinking-circle-b10 {
					top: 43%;
					left: 70%;
				}
				.blinking-circle-b11 {
					top: 30%;
					left: 77%;
				}
				.blinking-circle-b12 {
					top: 18%;
					left: 86%;
				}

			}
		}
	}

	@media screen and (max-width: 1200px) {
		.about1 {
			width: 100%;

			.about1-c {
				width: 100%;
				display: flex;
				padding: 80px 20px;

				.about1-info {
					width: 100%;
					display: grid;
					.about1-info-bg {
						width: 100%;
						height: auto;
					
					}

					.about1-info-h {
						font-size: 30px;
					}
					.about1-info-f1 {
						font-size: 15px;
						
						img{
							display: inline-block;
							margin-right:0 ;
							margin-left:0 ;
							height:93%;
						}
						p.about1-info-f1-p{
							width:42%;
							&.about1-info-f1-p-zh{
								width:42%;
							}
							
							padding-top:0;
							margin-top:0;
							display:inline-block;
							p{
								font-size:15px;
								padding-left:50px;
								padding-top:0;
								margin-top:5px;
								line-height:28px;
								span{
									display: block;
									margin-bottom:12px;
								}
							}
						}
						
					}

					.about1-info-f {
						width: 100%;
						margin-top: 30px;
						display: flex;

						img {
							width: 50%;
							height: 300px;
						}

						.about1-info-f-r {
							margin-left: 20px;
							width: calc(50% - 20px);

							.t {
								font-size: 16px;
								color: #332c2b;
								line-height: 20px;
							}

							.s {
								margin-top: 11px;
								height: 80px;
								border-bottom: 1px solid #f1f1f1;
								display: flex;

								.s-l {
									font-size: 40px;
								}

								.s-r {
									font-size: 16px;
								}
							}
						}
					}
				}
			}

			.about1-c1 {
				width: 100%;
				display: flex;
				padding-top: 50px;

				.about-bgimg {
					width: 100%;
					height: 100%;
					top: 0;
					left: 0;
				}

				.about1-c1-c {
					width: 100%;
					padding: 0 30px;

					.about1-c1-header {
						width: 100%;

						.h {
							height: 80px;
							line-height: 80px;
							border-bottom: 1px solid #aaa;

							div {
								width: 120px;
								height: 80px;
								font-size: 24px;
								border-bottom: 2px solid white;
							}
						}
					}

					.about1-c1-c1 {
						color: #fff;
						font-size:64px;
						p{
							display: inline-block;
							top:0;
							vertical-align: top;
							padding-left:10px;
							position:relative;
							font-size:16px;
						}
					}

					.about1-c1-c2 {
						font-size: 16px;
					}

					.about1-c1-c3 {
						margin-top: 20px;
						font-size: 16px;
					}

					.about1-c1-c4 {
						margin-top: 40px;
						height: 220px;
						display: flex;

						.item {
							flex: 1;
							height: 220px;
							border-left: 1px solid #aaa;
							padding: 20px;

							.t {
								font-size: 32px;

								span {
									font-size: 17px;
								}
							}

							.s {
								max-height: 90px;
								padding-top: 10px;
								font-size: 14px;
							}

							img {
								margin-top: 20px;
								width: 30px;
								height: 30px;
							}
						}
					}
				}
			}

			.about1-c2 {


				.about1-info-box {
					left: 0;
					width: 100%;
					height: 100%;

					.about1-info-box-h {
						padding-top: 30px;
						font-size: 24px;
					}

					.about1-info-box-s {
						margin-top: 29px;

						.about1-info-box-s-h {
							font-size: 20px;
							margin-bottom: 12px;
						}

						.about1-info-box-s-s {
							// width: 50%;
							width:65%;
							font-size: 16px;
							line-height: 18px;
							margin-bottom: 12px;
							position:relative;
							.about1-info-box-s-s-yuan {
								width: 6px;
								height: 6px;
								border-radius: 3px;
								margin-right: 6px;
								display: inline-block;
								position:absolute;
								top:13px;
							}
							

							.about1-info-box-s-s-sec {
								padding-left:15px;
								line-height: 30px;
								width: calc(100% - 12px);
								display: inline-block;
							}

						}

					}
				}

				.blinking-circle-b {
					font-size: 16px;
					display: flex;

					.blinking-circle-b-t {
						margin-top: 5px;
					}
				}

				.blinking-circle {
					width: 20px;
					height: 20px;
				}

				.blinking-circle-b1 {
					top: 87%;
					left: 20%;
				}

				.blinking-circle-b2 {
					top: 80%;
					left: 25%;
				}

				.blinking-circle-b3 {
					top: 73%;
					left: 34%;
				}

				.blinking-circle-b4 {
					top: 70%;
					left: 43%;
				}

				.blinking-circle-b5 {
					top: 64%;
					left: 47%;
				}

				.blinking-circle-b6 {
					top: 50%;
					left: 63%;
				}

				.blinking-circle-b7 {
					top: 30%;
					left: 78%;
				}

				.blinking-circle-b8 {
					top: 20%;
					left: 84%;
				}

			}
		}
	}

	@media screen and (max-width: 880px) {
		.about1 {
			width: 100%;

			.about1-c {
				width: 100%;
				display: flex;
				padding: 80px 0px;
				&.new-about1-c{
					padding-bottom:30px;
				}
				.about1-info {
					width: 100%;
					display:block;
					text-align: center;
					.about1-info-bg {
						width: 100%;
						height: auto;
					
					}

					.about1-info-h {
						width: 100%;
						font-size: 30px;
					}
					
					.about1-info-f1 {
						font-size: 13px;
						text-align: center;
						img{
							display:block;
							width:100%;
							margin:0 auto;
							margin-bottom:20px;
						}
						p.about1-info-f1-p{
							&.about1-info-f1-p-zh{
								width:96%;
							}
							width:96%;
							margin:0 auto;
							display: block;
							text-align: left;
							padding-right:0;
							margin-top:15px;
							p{
								padding:0 !important;
							}
						}
					}

					.about1-info-f {
						width: 100%;
						margin-top: 30px;
						padding: 0 12px;
						display: flex;
						flex-direction: column;

						img {
							width: 100%;
							height: 300px;
						}

						.about1-info-f-r {
							margin-top: 12px;
							width: 100%;

							.t {
								font-size: 16px;
								color: #332c2b;
								line-height: 20px;
							}

							.s {
								margin-top: 11px;
								height: 40px;
								border-bottom: 1px solid #f1f1f1;
								display: flex;

								.s-l {
									font-size: 19px;
								}

								.s-r {
									font-size: 14px;
								}
							}
						}
					}
				}
			}

			.about1-c1 {
				display: none;
			}
			
			.mobile-about1-c2{
				display: block;
				background-color: #f2f9f9;
				width:100%;
				height:auto;
				.mobile-abount1c2-title{
					font-size: 18px;
					text-align: center;
					padding-top:20px;
					padding-bottom:20px;
				}
				.new-pagination{
					bottom:20px;
				}
				.swiper-wrapper{
					padding:0 10px;
				}
				.swiper-container{
					height:340px !important;
				}
				.about1-info-box-s-s{
					margin-bottom:0px;
				}
				.about1-info-box-s-h{
					font-size:20px;
					color:#22A3D3;
					margin-bottom:10px;
				}
				.about1-info-box-s-s-sec{
					font-size:14px;
				}
			}
			
			.about1-c2 {
				display:none;
				.about1-info-box {
					left: 0;
					width: 100%;
					height: 100%;

					.about1-info-box-h {
						padding-top: 20px;
						font-size: 18px;
					}

					.about1-info-box-s {
						margin-top: 10px;
						padding: 0 20px;

						.about1-info-box-s-h {
							font-size: 15px;
							margin-bottom: 10px;
						}

						.about1-info-box-s-s {
							width: 100%;
							font-size: 14px;
							line-height: 16px;
							margin-bottom: 10px;

							.about1-info-box-s-s-yuan {
								width: 4px;
								height: 4px;
								border-radius: 2px;
								margin-right: 6px;
							}

							.about1-info-box-s-s-sec {
								width: calc(100% - 10px);
							}

						}

					}
				}

				.blinking-circle-b {
					display: none;
				}


			}

			.about1-c1-c4 {
				margin-top: 30px;
				height: 220px;
				display: flex;

				.item {
					padding: 12px;
				}
			}
		}
	}

	.icon {
		display: inline-block;
		width: 6px;
		position: relative;
		height: 6px;
		background: rgb(0, 141, 142);
		border-radius: 50%;
		top: -1px;
	}
</style>